import {isLoaded} from 'Core/models/Async';
import {ValidatableEmail, ValidEmail} from 'Core/models/Email';
import {NonEmptyString, StringUnion} from 'Core/models/EmptyString';
import {InvalidPhoneNumber, PhoneNumber} from 'Core/models/PhoneNumber';
import {ValidatableNonEmptyString} from 'Core/models/ValidatableNonEmptyString';
import {isRight} from 'fp-ts/lib/Either';

export type BOSAndBeneficiariesUser = {
  username?: ValidatableNonEmptyString;
  firstName?: StringUnion;
  lastName?: StringUnion;
  email?: ValidatableEmail;
  phoneNumber?: PhoneNumber;
};

export enum UserType {
  BeneficiariesUser = 1,
  BOSToolsUser,
}

export class ValidBOSAndBeneficiariesUser {
  public static create(bosAndBeneficiariesUser: BOSAndBeneficiariesUser) {
    const isPhoneNumberValidOrNotSpecified = !(bosAndBeneficiariesUser.phoneNumber instanceof InvalidPhoneNumber);
    const isEmailValidToUse =
      isLoaded(bosAndBeneficiariesUser.email!) &&
      isRight(bosAndBeneficiariesUser.email.Data) &&
      bosAndBeneficiariesUser.email.Data.right instanceof ValidEmail;
    const isUsernameValidToUse =
      isLoaded(bosAndBeneficiariesUser.username!) &&
      isRight(bosAndBeneficiariesUser.username.Data) &&
      bosAndBeneficiariesUser.username.Data.right instanceof NonEmptyString;

    const isValid =
      bosAndBeneficiariesUser?.firstName instanceof NonEmptyString &&
      bosAndBeneficiariesUser?.lastName instanceof NonEmptyString &&
      isEmailValidToUse &&
      isUsernameValidToUse &&
      isPhoneNumberValidOrNotSpecified;

    return isValid
      ? new ValidBOSAndBeneficiariesUser(bosAndBeneficiariesUser)
      : InvalidBOSAndBeneficiariesUser.create(bosAndBeneficiariesUser);
  }

  private constructor(public readonly bosAndBeneficiariesUser: BOSAndBeneficiariesUser) {}
}

export class InvalidBOSAndBeneficiariesUser {
  public static create(bosAndBeneficiariesUser: BOSAndBeneficiariesUser) {
    return new InvalidBOSAndBeneficiariesUser(bosAndBeneficiariesUser);
  }

  private constructor(public readonly bosAndBeneficiariesUser: BOSAndBeneficiariesUser) {}
}
